/**
 * Operation tabs inside the Add/Exclude Products configurations step.
 * Maps to {@link AddExcludeProductsDirection} where applicable.
 */
export enum AddExcludeProductsOperationTab {
    Exclude = 'exclude',
    Include = 'include',
    ManageRules = 'manage-rules'
}
